const FormatCurrency = (amount) => {
  const settings = { style: 'currency', currency: 'MXN' }
  const number = new Intl.NumberFormat('en-MX', settings)

  return number.format(amount)
}

const Sum = (total, models, model = null) => {
  let modelPrice = 0

  if(model) {
    if (model.checked) {
      modelPrice = parseFloat(model.getAttribute('price'))
    }
  } else {
    models.forEach((model) => {
      if (model.checked) {
        modelPrice = parseFloat(model.getAttribute('price'))
      }
    })
  }

  total.value = FormatCurrency(modelPrice)
}

export const Modality = () => {
  const form = document.querySelector('#quote-form')
  const searchBtn = form.querySelector('.quote-sales-search-button')
  const models = form.querySelectorAll('[name="model"]')

  searchBtn.addEventListener('click', (e) => {
    models.forEach((model) => {
      model.checked = false;
    })
  })
}

const QuoteForm = () => {
  const form = document.querySelector('#quote-form')

  if (!form) return

  const total = form.querySelector('[name="total"]')
  const models = form.querySelectorAll('[name="model"]')
  let currentModel

  models.forEach((model) => {
    model.addEventListener('change', (e) => {
      currentModel = model
      Sum(total, models, model)
    })
  })

  // setTimeout(() => {
  //   modality.dispatchEvent(new Event('change'))
  // }, 10)
}
export default QuoteForm
